
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
// import { auth } from '../../helpers/Firebase';
import API, { auth } from '../../constants/api';
import {
  LOGIN_USER_OTT,
  LOGOUT_USER,
  CHECK_EMAIL_FETCH,
  CHECK_TEL_FETCH
} from '../actions';

import {
  loginUserSuccess,
  loginUserError,
  checkMailFetchSuccess,
  checkMailFetchFail,
  checkTelFetchSuccess,
  checkTelFetchFail
} from './actions';

const loginWithEmailPasswordAsync = async (req) =>
  await API.post('auth/login', {
    'memberType': req.memberType,
    'email': req.email,
    'password': req.password,
    'pushId': req.pushId,
    'socialId': req.socialId
  }, {
    "headers": auth
  })
    .then(authUser => authUser)
    .catch(error => error);

function* loginWithEmailPassword({ payload }) {
  const { user } = payload;
  // console.log('payload -> ', payload)
  try {

    const loginUser = yield call(loginWithEmailPasswordAsync, user);
    if (loginUser.data.StatusCode === "0000") {
      localStorage.setItem('user_info', JSON.stringify(loginUser.data.ResultValues));
      localStorage.setItem('user_id', loginUser.data.ResultValues.member_id);
      yield put(loginUserSuccess(loginUser.data.ResultValues));
    } else {
      yield put(loginUserError(loginUser.data.Message));
    }
  } catch (error) {
    yield put(loginUserError(error));
    // console.warn('error login', error)
  }
}

const logoutAsync = async (history) => {
  await auth.signOut().then(authUser => authUser).catch(error => error);
  history.push('/')
}

function* logout({ payload }) {
  const { history } = payload
  try {
    yield call(logoutAsync, history);
    localStorage.removeItem('user_id');
  } catch (error) {
  }
}

/* check mail */
const checkMailFetchAsync = async (req) =>
  await API.post('/auth/checkemail', {
    "memberEmail": req.memberEmail
  },
    {
      headers: auth
    }
  )
    .then((data) => data)
    .catch((error) => error)

function* checkMailFetch({ payload }) {
  const { checkMail } = payload
  try {
    const checkMailFetch = yield call(checkMailFetchAsync, checkMail)

    if (checkMailFetch.data.StatusCode === '0000') {
      yield put(checkMailFetchSuccess(checkMailFetch.data.StatusCode))
    } else {
      yield put(checkMailFetchFail(checkMailFetch.data.Message, checkMailFetch.data.StatusCode))
    }
  } catch (error) {
    yield put(checkMailFetchFail(error))
  }
}

/* check tel */
const checkTelFetchAsync = async (req) =>
  await API.post('/auth/checktel', {
    "memberTel": req.memberTel
  },
    {
      headers: auth
    }
  )
    .then((data) => data)
    .catch((error) => error)

function* checkTelFetch({ payload }) {
  const { checkTel } = payload
  try {
    const checkTelFetch = yield call(checkTelFetchAsync, checkTel)

    if (checkTelFetch.data.StatusCode === '0000') {
      yield put(checkTelFetchSuccess(checkTelFetch.data.StatusCode))
    } else {
      yield put(checkTelFetchFail(checkTelFetch.data.Message, checkTelFetch.data.StatusCode))
    }

  } catch (error) {
    yield put(checkTelFetchFail(error))
  }
}

export function* watchLoginUser() {
  yield takeEvery(LOGIN_USER_OTT, loginWithEmailPassword);
  yield takeEvery(CHECK_EMAIL_FETCH, checkMailFetch);
  yield takeEvery(CHECK_TEL_FETCH, checkTelFetch);
}

export function* watchLogoutUser() {
  yield takeEvery(LOGOUT_USER, logout);
}

export default function* rootSaga() {
  yield all([
    fork(watchLoginUser),
    fork(watchLogoutUser),
  ]);
}
